import { NgModule } from '@angular/core';
import { GroupAssigmentsCompletePipe } from '../pipes/group-assigments-complete.pipe';

@NgModule({
  declarations: [GroupAssigmentsCompletePipe],
  exports: [GroupAssigmentsCompletePipe],
})
export class GroupAssigmentsCompletePipeModule {}
